module.exports = __webpack_public_path__ + "al.svg?deee103be0d7bb990ce5c4ce1531fb99";